export function EloLinkMark() {
  return (
    <svg
      viewBox="84 88 321 307"
      fillRule="evenodd"
      aria-hidden="true"
      focusable="false"
    >
      <g
        className="login-mark-green"
        stroke="currentColor"
        strokeWidth=".65"
        strokeLinejoin="round"
      >
        <path d="M193 319 197 336 189 358 173 371 152 373 136 366 123 348 122 328 128 314 137 305 149 299 175 300 209 266 206 254 207 240 213 226 225 214 237 209 252 208 264 211 275 218 282 227 279 235 264 238 252 231 239 233 231 242 230 255 237 266 264 274 278 273 277 279 269 286 253 292 236 291 223 285 192 315Z M164 354 175 347 179 332 171 319 155 316 143 324 140 330 140 341 148 352 155 355Z" />
        <path d="M272 383 258 386 228 386 206 382 186 374 196 365 202 354 235 361 267 359 290 352 321 333 345 304 357 275 360 260 360 231 356 215 371 200 377 198 384 223 385 262 377 295 366 318 350 340 328 360 301 375Z" />
        <path d="M202 103 230 97 262 98 297 108 311 115 315 120 307 128 302 139 285 130 257 123 227 123 199 130 180 113Z" />
        <path d="M98 276 95 259 95 232 100 207 110 187 127 203 120 232 120 258 132 297 121 306 115 316 104 296Z" />
        <path d="M268 206 264 203 314 155 316 168 322 178 284 216Z" />
      </g>
      <path
        className="login-mark-blue"
        d="M260 266 252 264 241 255 240 248 244 242 253 241 263 246 282 243 337 190 322 179 324 172 318 158 313 155 314 143 322 127 334 117 349 112 366 113 383 122 389 129 395 146 394 162 386 177 374 188 366 190 298 258 278 267Z M342 135 336 140 332 150 335 164 347 173 355 174 365 171 375 159 376 149 373 141 368 135 359 131 350 131Z"
      />
      <g className="login-mark-lime">
        <path d="M99 104 132 106 157 113 179 125 197 142 209 162 214 179 214 202 208 219 197 190 179 166 149 142 126 133 159 159 183 187 199 216 203 236 189 222 138 199 117 180 105 159 99 141 95 116 95 104Z" />
        <path d="M373 142 375 158 366 170 360 173 347 173 334 162 333 146 341 135 358 131 366 134Z" />
        <path d="M142 328 143 324 152 317 167 317 178 328 177 344 166 354 152 354 141 344 140 330Z" />
      </g>
    </svg>
  );
}
